<div class="flex flex-col w-full max-w-lg">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 pt-6 pb-2">
        <div class="flex items-center gap-3">
            <mat-icon class="text-yellow-500" style="font-size:28px; width:28px; height:28px;">schedule</mat-icon>
            <h2 class="text-xl font-semibold m-0">¿Sigues ahí?</h2>
        </div>
        <button mat-icon-button (click)="aceptar()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Mensaje -->
    <mat-dialog-content class="px-6 pb-4">
        <p class="text-sm text-secondary m-0">
            Tu sesión está por cerrarse por inactividad.
        </p>
    </mat-dialog-content>

    <!-- Pie -->
    <mat-dialog-actions align="end" class="px-6 pb-4 pt-2">
        <button mat-flat-button color="primary" (click)="aceptar()">
            Aceptar
        </button>
    </mat-dialog-actions>

</div>
